module.exports = __webpack_public_path__ + "assets/img/dzh-11.b83075ed.jpg";